import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { initializeRole } from "../../../actions/role";
import { initializeLogin } from "../../../actions/login";
import { Form, Input, Card, Row, Col, Button, Select, Icon, notification } from 'antd';
import ImageUpload from '../../../containers/ImageUpload';
import AdminOverLimitModal from '../../../containers/CustomModal/AdminOverLimitModal';
import { get, put, post, ppost } from '../../../utils';
import config from '../../../config.json'
import './style.scss'

const FormItem = Form.Item;
const { Meta } = Card;
const { TextArea } = Input;
const Option = Select.Option;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description,
    });
};

class Administrator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstname: '',
            lastname: '',
            telephone: '',
            password: null,
            roleId: null,
            originalRoleId: null,
            imageAvatarList: [],
            roleList: [],
            visible: false,
        }
    }


    getRoleList() {
        let url = '/api/account/role/list';
        get(url)
            .then(responses => {
                this.setState({ roleList: responses })
            })
            .catch(err => {
                console.log(err.message)
            })
    }

    getAdministratorDetail() {
        const { editId, folderName } = this.props
        let url = '/api/user/administrator/' + editId;
        get(url)
            .then(response => {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }
                let imageAvatarList = []
                if (response.avatar) {
                    imageAvatarList = [{
                        view: `${process.env.REACT_APP_API_PROTOCOL}://${process.env.REACT_APP_API_HOSTNAME}:${process.env.REACT_APP_API_PORT}/uploads/${folderName}/${response.avatar}`,
                        file: null,
                        name: response.avatar
                    }]
                }
                this.setState({
                    firstname: response.firstname,
                    lastname: response.lastname,
                    telephone: response.telephone,
                    username: response.username,
                    roleId: response.role_id,
                    originalRoleId: response.role_id,
                    imageAvatarList: imageAvatarList,
                })
            })
            .catch(err => {
                console.log(err.message)
            })
    }

    componentDidMount() {
        this.getRoleList()
        if (this.props.editId) {
            this.getAdministratorDetail()
        }
    }

    getInitializeRoleDetail(roleId) {
        let url = '/api/account/role/detail/' + roleId;
        get(url)
            .then(responses => {
                this.props.initializeRole(responses)
                if (this.props.administratorId == this.props.editId) {
                    this.getInitializeLogin()
                } else {
                    this.props.backpage()
                }
            })
            .catch(err => {
                console.log(err.message)
            })
    }

    getInitializeLogin() {
        const { administratorId } = this.props
        let url = '/api/crm/administrator/user/administrator/initialize/maincustomer';
        let data = { user_administrator_id: administratorId }
        post(url, data)
            .then(responses => {
                this.props.initializeLogin(responses)
                this.props.backpage()
            })
            .catch(err => {
                console.log(err.message)
            })
    }

    async uploadImageToServer(formData) {
        let url = '/api/crm/administrator/upload/file'
        return await ppost(url, formData)
            .then(response => {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }
                return response
            })
            .catch(err => {
                console.log(err.message)
                return []
            })
    }

    async updateAdministrator() {
        const { username, password, firstname, lastname, telephone, imageAvatarList, roleId, originalRoleId } = this.state
        if (!firstname || firstname == '') {
            openNotificationWithIcon('warning', 'System notification', 'Please enter "Firstname".')
            return
        }
        if (!lastname || lastname == '') {
            openNotificationWithIcon('warning', 'System notification', 'Please enter "Lastname".')
            return
        }
        if (!telephone || telephone == '') {
            openNotificationWithIcon('warning', 'System notification', 'Please enter "Telephone".')
            return
        }

        if (!roleId || roleId == '') {
            openNotificationWithIcon('warning', 'System notification', 'Please select "Role".')
            return
        }
        if (!username || username == '') {
            openNotificationWithIcon('warning', 'System notification', 'Please enter "Username".')
            return
        }
        if (!this.props.editId && (!password || password == '')) {
            openNotificationWithIcon('warning', 'System notification', 'Please enter "Password".')
            return
        }
        if (username.length < 6) {
            openNotificationWithIcon('warning', 'System notification', 'Please enter your username least 6 characters.')
            return
        }
        if ((!this.props.editId && !password) && password.length < 6) {
            openNotificationWithIcon('warning', 'System notification', 'Please enter your password least 6 characters.')
            return
        }
        let data = {
            firstname: firstname,
            lastname: lastname,
            telephone: telephone,
            role_id: roleId,
            username: username,
            password: password,
            avatar: null,
            user: this.props.administratorId
        }

        let uploadFileList = imageAvatarList.filter(item => item.file)
        if (uploadFileList.length) {
            let formData = new FormData();
            uploadFileList.map((item, index) => formData.append("image" + index, item.file))
            let fileNameList = await this.uploadImageToServer(formData)
            if (fileNameList.length) {
                data.avatar = fileNameList[0]
            }
        } else if (imageAvatarList.length) {
            data.avatar = imageAvatarList[0].name
        }
        if (this.props.editId) {
            let url = '/api/user/administrator/' + this.props.editId
            put(url, data)
                .then(response => {
                    if (response.status >= 400) {
                        throw new Error("Bad response from server");
                    }
                    if (!response.success) {
                        switch (response.error.code) {
                            case 'DUPLICATE_EMAIL':
                                openNotificationWithIcon('error', 'System notification', 'Duplicate E-mail.')
                                break;
                            case 'DUPLICATE_USERNAME':
                                openNotificationWithIcon('error', 'System notification', 'Duplicate Username.')
                                break;
                            case 'DUPLICATE_TELEPHONE':
                                openNotificationWithIcon('error', 'System notification', 'Duplicate Telephone.')
                                break;
                        }
                    } else {
                        console.log('this.props.administratorId', this.props.administratorId)
                        console.log('this.props.editId', this.props.editId)
                        if (originalRoleId != roleId) {
                            this.getInitializeRoleDetail(roleId)
                        } else if (this.props.administratorId == this.props.editId) {
                            this.getInitializeLogin()
                        } else {
                            this.props.backpage()
                        }
                    }

                })
                .catch(err => {
                    console.log(err.message)
                })
        } else {
            let url = '/api/user/administrator';
            post(url, data)
                .then(response => {
                    if (response.status >= 400) {
                        throw new Error("Bad response from server");
                    }
                    if (!response.success) {
                        switch (response.error.code) {
                            case 'OVER_LIMIT_ADMINISTRATOR':
                                this.showAdminOverLimitModal()
                                break;
                            case 'DUPLICATE_USERNAME':
                                openNotificationWithIcon('error', 'System notification', 'Duplicate Username.')
                                break;
                            case 'DUPLICATE_EMAIL':
                                openNotificationWithIcon('error', 'System notification', 'Duplicate E-mail.')
                                break;
                            case 'DUPLICATE_TELEPHONE':
                                openNotificationWithIcon('error', 'System notification', 'Duplicate Telephone.')
                                break;
                        }
                    } else {
                        this.props.backpage()
                    }

                })
                .catch(err => {
                    console.log(err.message)
                })
        }
    }

    showAdminOverLimitModal() {
        this.setState({ visible: true })
    }

    onClickOk() {
        this.updateAdministrator()
    }
    onClickCancel() {
        this.setState({
            role_id: null,
            username: '',
            password: '',
            name: '',
            avatar: null,
        })
        this.props.backpage()
    }
    render() {
        const formItemLayout = {
            // labelCol: {
            //     xs: { span: 8 },
            //     sm: { span: 4 },
            // },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };

        return (
            <div className='administrator-page-wrapper' style={{ backgroundColor: '#FFFFFF', height: '90vh' }}>
                <Row className="header-card" >
                    <Col span={12} style={{ textAlign: 'left' }} onClick={() => this.props.backpage()} style={{ cursor: 'pointer' }}>
                        <Icon style={{ fontSize: 25, fontWeight: 500, color: 'rgb(72, 197, 235)' }} type="left" />
                        <span style={{ fontSize: 25, fontWeight: 500, color: 'rgb(72, 197, 235)' }} >{this.props.editId ? 'Edit  User Staff' : 'Create User Staff'}</span>
                    </Col>
                    <Col span={12} style={{ textAlign: 'right' }}>
                        <Button style={{ marginLeft: 2, marginRight: 2, backgroundColor: '#ffffff', color: 'rgb(72, 197, 235)', border: '1px solid rgb(72, 197, 235)' }} onClick={() => this.onClickCancel()}>{'Cancel'}</Button>
                        <Button style={{ marginLeft: 2, marginRight: 2, backgroundColor: 'rgb(72, 197, 235)', color: '#ffffff', border: '1px solid rgb(72, 197, 235)' }} onClick={() => this.onClickOk()} >{'Save'}</Button>
                    </Col>
                </Row>
                <Card className="cardstyle">
                    <Form>
                        <Row gutter={24}>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} >
                                <FormItem {...formItemLayout} label={'Firstname'} required={true}>
                                    <Input
                                        value={this.state.firstname}
                                        onChange={(event) => this.setState({ firstname: event.target.value })}
                                        disabled={this.props.administratorId != this.props.administratorId}
                                    />
                                </FormItem>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} >
                                <FormItem {...formItemLayout} label={'Lastname'} required={true}>
                                    <Input
                                        value={this.state.lastname}
                                        onChange={(event) => this.setState({ lastname: event.target.value })}
                                        disabled={this.props.administratorId != this.props.administratorId}
                                    />
                                </FormItem>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} >
                                <FormItem {...formItemLayout} label={'Telephone'} required={true}>
                                    <Input
                                        value={this.state.telephone}
                                        onChange={(event) => this.setState({ telephone: event.target.value })}
                                        disabled={this.props.administratorId != this.props.administratorId}
                                    />
                                </FormItem>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} >
                                <FormItem {...formItemLayout} label={'Role'} required={true}>
                                    <Select
                                        value={this.state.roleId}
                                        onChange={(value) => this.setState({ roleId: value })}
                                    >
                                        {this.state.roleList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)}
                                    </Select>
                                </FormItem>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} >
                                <FormItem {...formItemLayout} label={'Username'} required={true}>
                                    <Input
                                        value={this.state.username}
                                        onChange={(event) => this.setState({ username: event.target.value })}
                                        disabled={true}
                                    />
                                </FormItem>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} >
                                <FormItem {...formItemLayout} label={'Password'} required={true}>
                                    <Input
                                        type={'password'}
                                        value={this.state.password}
                                        onChange={(event) => this.setState({ password: event.target.value })}
                                        disabled={this.props.administratorId != this.props.administratorId}
                                    />
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} >
                                <Row>
                                    <Col sm={24} md={24} lg={24} style={{ flexDirection: 'row' }}>
                                        <ImageUpload
                                            label={'Upload image avatar'}
                                            limit={1}
                                            dataSource={this.state.imageAvatarList}
                                            updateDataSource={(dataSource) => this.setState({ imageAvatarList: dataSource })}
                                            disabled={this.props.administratorId != this.props.administratorId}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <AdminOverLimitModal
                            visible={this.state.visible}
                            onClose={() => this.setState({ visible: false })}
                        />
                    </Form>
                </Card>

            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    isAuthenticated: state.login.isAuthenticated,
    administratorId: state.login.id,
    folderName: state.login.folderName,
})

const mapDispatchToProps = (dispatch) => ({
    initializeRole: (payload) => dispatch(initializeRole(payload)),
    initializeLogin: (payload) => dispatch(initializeLogin(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(Administrator);

